import Cookies from 'js-cookie';

export const HOUSE_OVERRIDE_COOKIE = 'houseOverride';

/**
 * Cookie options for the house override, matching auth cookie host rules.
 *
 * Domain handling:
 * - On proxibid.com subdomains (incl. localdev.proxibid.com): use `.proxibid.com`.
 * - On localhost (and any non-proxibid.com host): omit `domain` so the browser
 *   scopes the cookie to the current host. Setting `domain: '.proxibid.com'` on
 *   localhost is rejected by browsers and leaves SSR without the override —
 *   LotCreatePage then fetches with JWT membership house and 404s.
 */
const getCookieOptions = () => {
    const isBrowser = typeof window !== 'undefined';
    const hostname = isBrowser ? window.location.hostname : '';
    const isProxibidHost = hostname.endsWith('.proxibid.com');
    const isSecure = isBrowser && window.location.protocol === 'https:';

    return {
        ...(isProxibidHost ? { domain: '.proxibid.com' } : {}),
        path: '/',
        sameSite: 'Lax' as const,
        secure: isSecure,
    };
};

/**
 * Writes the active house override cookie.
 */
export const setHouseOverrideCookie = (houseId: string): void => {
    Cookies.set(HOUSE_OVERRIDE_COOKIE, houseId, getCookieOptions());
};

/**
 * Reads the raw cookie value.
 * Returns undefined if the cookie is not set.
 */
export const getHouseOverrideCookieValue = (): string | undefined => {
    return Cookies.get(HOUSE_OVERRIDE_COOKIE);
};

/**
 * Removes the active house override cookie.
 * Call on logout and "Go Home".
 */
export const clearHouseOverrideCookie = (): void => {
    Cookies.remove(HOUSE_OVERRIDE_COOKIE, getCookieOptions());
};
